import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/message.svg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { style: {"max-width":"550px"} }
const _hoisted_3 = { class: "card bg-white border-0 rounded-10 mb-4 text-center" }
const _hoisted_4 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"mb-3 mb-md-4\"><img src=\"" + _imports_0 + "\" alt=\"logo\"></div><img src=\"" + _imports_1 + "\" class=\"mb-3 mb-md-4\" alt=\"message\"><h4 class=\"fs-20 fw-semibold mb-2\">Success !</h4><p class=\"mb-4\"> A email has been send to <strong>hello@trezo.com</strong>. Please check for an email from company and click on the included link to reset your password. </p>", 4)),
          _createVNode(_component_RouterLink, {
            to: "/authentication/login",
            class: "btn btn-primary fs-16 fw-medium text-dark py-2 px-4 text-white w-100"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Confirm Mail ")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}